<template>
    <cms-block v-bind="$props" @block-selected="selectBlock">
        <cms-component-image comp-id="logo" class="mb" :component="block.logo" v-bind="componentProps"/>
        <template v-if="block.mediaProxy.layout === 'default'">
            <cms-component-navigation-links comp-id="links" :component="block.links" v-bind="componentProps"/>
            <cms-component-text comp-id="linksTitle" :component="block.linksTitle" placeholder="Title|Titre" v-bind="componentProps"/>
            <cms-component-text comp-id="socialLinksTitle" :component="block.socialLinksTitle" placeholder="Title|Titre" v-bind="componentProps"/>
            <cms-component-social-links comp-id="socialLinks" :component="block.socialLinks" v-bind="componentProps"/>
        </template>
        <b-row class="mt" v-else>
            <b-col :cols="cols" :order="block.mediaProxy.layout === 'row-right' ? 2 : 0" :class="{ 'mb': isMobileLayoutOrPreview || block.mediaProxy.layout === 'default'}">
                <cms-component-text comp-id="linksTitle" :component="block.linksTitle" placeholder="Title|Titre" v-bind="componentProps"/>
                <cms-component-navigation-links comp-id="links" :component="block.links" v-bind="componentProps"/>
            </b-col>
            <b-col :cols="cols" :class="{ 'mt': isMobileLayoutOrPreview || block.mediaProxy.layout === 'default'}">
                <cms-component-text comp-id="socialLinksTitle" :component="block.socialLinksTitle" placeholder="Title|Titre" v-bind="componentProps"/>
                <cms-component-social-links comp-id="socialLinks" :component="block.socialLinks" v-bind="componentProps"/>
            </b-col>
        </b-row>
        <cms-component-text comp-id="copyright" :component="block.copyright" v-bind="componentProps"/>
    </cms-block>
</template>

<script>
import CmsBlock from "@/components/editor/rendering/blocks/cms-block.vue";

// cms-block-footer #hot-reload-debug
export default {
    name: `cms-block-footer`,
    components: {CmsBlock},
    extends: CmsBlock,
    computed: {
        cols() {
            if (this.isMobileLayoutOrPreview) {
                return 12;
            }
            return this.block.mediaProxy.layout === `default` ? 12 : ``;
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
